import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { buttonBaseStyle, buttonSizes, buttonKinds, shapes } from './styles';
import * as meta from '../../meta-data.json';
import { paddingSize } from '../../Utilities/utils/Theming';

export const overrides = (props: any, newProps: any, childrenText: any, ariaChecked: any) => {
	const {
		iconBefore,
		iconAfter,
		isLoading,
		isSelected,
		startEnhancer,
		endEnhancer,
		groupPosition,
		parentTheme,
		buttongroupShape,
		ellipsis,
		...rest
	} = props;

	const _iconMargin =
		props.size == 'large'
			? 'var(--epods--button-large-icon-margin)'
			: props.size == 'compact'
				? 'var(--epods--button-compact-icon-margin)'
				: props.size == 'mini'
					? 'var(--epods--button-mini-icon-margin)'
					: 'var(--epods--button-default-icon-margin)';

	return {
		BaseButton: {
			style: ({ isSelected, $theme }: any) => {
				const _ellipsis = ellipsis ? {
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					display: 'inline-block !important'
				} : {}
				return {
					...buttonBaseStyle(props),
					...buttonSizes(props, props, childrenText),
					...buttonKinds(newProps, isSelected, props.navigationStyle),
					...shapes(props),
					position: 'relative',
					..._ellipsis,
					maxWidth: '100%',
				};
			},
			props: {
				...getBaseCustomProps(props),
				'data-disabled': props.disabled,
				'data-active': props.isSelected,
				'data-theme': props.theme,
				'data-size': props.size,
				...rest,
				'data-epo': `epo-button-${meta.version}`,
				part: `epo-button-${meta.version}`, //TODO suffix the global version for MFE with different versions
				...ariaChecked,
			},
		},
		StartEnhancer: {
			style: () => {
				return !props.iconAfter && !props.children && !props.text
					? { marginRight: '0', color: 'inherit' }
					: { marginRight: _iconMargin, color: 'inherit' };
			},
		},
		EndEnhancer: {
			style: () => {
				return !props.iconBefore && !props.children && !props.text
					? { marginLeft: '0', color: 'inherit' }
					: { marginLeft: _iconMargin, color: 'inherit' };
			},
		},
		LoadingSpinner: {
			style: () => {
				return {
					width: 'var(--epods--font-size-p)',
					height: 'var(--epods--font-size-p)',
					borderRightColor: 'var(--epods--color-btn-link-disabled)',
					borderBottomColor: 'var(--epods--color-btn-link-disabled)',
					borderLeftColor: 'var(--epods--color-btn-link-disabled)',
					borderTopColor: 'white',
				};
			},
		},
	};
};
